import { render, staticRenderFns } from "./RejectAccount.vue?vue&type=template&id=7821d851&"
import script from "./RejectAccount.vue?vue&type=script&lang=js&"
export * from "./RejectAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports